import React from "react";
import "./styles.css";
import { useHistory } from "react-router-dom";
import { HistorySharp } from "@material-ui/icons";
export default function BannerAboutUs(props) {
    let history = useHistory();
    
    return (
        <>
            <div className="contenedorBannerAboutUs">
                {/* <div className="tituloPill">
                    <h1>INNOVANDO</h1>
                    <h2>TUS PROCESOS DE TRABAJO</h2>
                </div> */}
               
            </div>
        </>
    );
}
